import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { getWhatsAppFlowDetailsCacheKey } from "./constants";
import type { WhatsAppFlowDetails } from "./types";

export const getWhatsAppFlowDetails = reactQueryFetcherAdapter(
  getWhatsAppFlowDetailsCacheKey,
  async (signal, appGroupId: string, messagingServiceId: string, flowId: string): Promise<WhatsAppFlowDetails> => {
    return await fetch(
      `/engagement/${appGroupId}/whatsapp/flow_details/${messagingServiceId}/${flowId}`,
      "GET",
      undefined,
      {
        signal,
      },
      { propagateFetchRequestError: false }
    );
  }
);
